<template>
   <v-card>
    <v-card-title>
      transactions
      <v-spacer></v-spacer>
      <form v-on:submit.prevent="reload">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      </form>

      <v-menu offset-y v-model="menu" :close-on-content-click="false" :close-on-click="true">
              <template v-slot:activator="{ on }">
                <v-btn class="primary" v-on="on">Filter <v-icon right dark>
                    mdi-filter-variant
                  </v-icon></v-btn>
              </template>
              <v-card class="pa-5" flat>
                <label for="">Wallet</label>
                <v-select :items="coins" v-model="wallet" item-text="coinName" item-value="id" dense outlined
                  return-object></v-select>
                <label for="">Status</label>
                <v-select :items="['approved', 'declined', 'processing']" v-model="status" dense outlined
                  return-object></v-select>
                <label for="">Date</label>
                <br />
                <DateRangePicker v-model="dateRange" />

                <v-card-actions>
                  <v-btn rounded depressed @click="reset">Reset</v-btn>
                  <v-btn color="primary" @click="reload()" rounded depressed>Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
    </v-card-title>

    <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Coin
                    </th>
                    <th class="text-left">
                      Name
                    </th>
                    <th class="text-left">
                      Transaction ID
                    </th>
                    <th class="text-left">
                      Amount ($)
                    </th>
                    <th class="text-left">
                      Amount (N)
                    </th>
                    <th class="text-left">
                      Quantity
                    </th>
                    <th class="text-left">
                      Date
                    </th>
                    <th class="text-left">
                      Status
                    </th>
                  
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in trades" :key="item.id">
                    <td> <div class="logo-container">
  <img :src="item.coin.logoURL" alt="Your Logo">
  <span class="logo-text">{{ item.coin.coinShortName }}</span>
</div></td>
                    <td>{{ item.user.profile.firstname + " " +  item.user.profile.lastname }}</td>
                    <td>
                      {{ item.reference }}
                    </td>
                    <td>{{ formatMoney(item.amount_usd) }}</td>
                    <td>{{ formatMoney(item.amount_naira) }}</td>
                    <td>{{ item.amount }}</td>

                    <td>{{ formatDateDisplay(item.created) }}</td>

                    <td>
                      <v-chip v-if="item.status === 'approved'" class="ma-2" color="success">
                        {{ item.status }}
                      </v-chip>
                      <v-chip v-if="item.status == 'declined'" class="ma-2" color="error">
                        {{ item.status }}
                      </v-chip>
                      <v-chip v-if="item.status == 'pending' || item.status == 'processing'" class="ma-2" color="warning">
                        {{ item.status }}
                      </v-chip>
                    </td>
                
                  </tr>
                </tbody>
              </template>

            </v-simple-table>
            <v-row>
                <v-col>
                    <v-pagination
      v-model="page"
      :length="count"
      @input="loadTrades"
      rounded="circle"
    ></v-pagination>
                </v-col>
            </v-row>
   
   </v-card>
  </template>


  <script>
  
 // =========== IMPORT SERVICE =========
import DateRangePicker from "@/components/DateRangePicker.vue";

// =========== IMPORT SERVICE =========
import { CryptoService } from "@/services";
import app from '@/main'
import moment from "moment"
import { formatMoney } from '@/utils/moneyFormatter';

  export default {
    data: ()=>({ 
      dateRange: {},
     search: '',
     items: ['approve', 'decline'],
     status: '',
     wallet: '',  
     coins: [],
     trades: [],
     count: 0,
     limit:10,
     page: 1,
     menu: false,

    }),
    async mounted() {
        this.loadTrades();
        this.getAllCoins();
    
    },
   methods: {
    formatMoney(amount){
      return formatMoney(amount, false)
    },
    pad(num) {
  return num < 10 ? `0${num}` : num;
},
  formatDateDisplay(dateString) {
 

     return  moment(dateString).format('MMMM Do YYYY, h:mm:ss a');
},
    async loadTrades() {
      try {
        const filter = {
          page: this.page, limit: this.limit,
          search: this.search, coin_short_name: this.wallet.coinShortName, status: this.status, start_date: this.dateRange.startDate, end_date: this.dateRange.endDate
        };
        console.log(filter)
        let data = await CryptoService.loadCoinTrades(this.cleanUpFilter(filter));
        if (data) {
          this.trades = data.trades;
          this.count = Math.ceil( Number(data.total / this.limit) );

        }
      } catch (error) {
        app.$store.dispatch('toast', {
          message: 'something went wrong',
          variant: 'error'
        })
      }
    },
    async reload() {
      this.page = 1;
      await this.loadTrades();
      this.menu = false;
    },
    async reset() {
      this.search = '';
      this.dateRange = {};
      this.wallet = '';
      this.page = 1;
      this.limit = 10;
      this.status = '';
      this.loadTrades();
      this.menu = false;
    },
    async getAllCoins() {
      this.loading = true;
      let data = await CryptoService.getCoins();
      if (data) {
        this.loading = false;
        this.coins = data;


      }
    },
    cleanUpFilter(obj) {
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === "") {
          delete obj[key];
        }
      });
      let check = Object.keys(obj).length === 0;
      return check ? null : obj;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
   },
   components: {
    DateRangePicker
   },
   watch: {
    search (value) {
      if (!value) {
        this.reload()
      }
    }
   }
  }
</script>

<style>
td {
    size: 0.1rem;
}
</style>